module.exports = __webpack_public_path__ + "img/5.7b5a6a33.jpg";